<template>
  <div class="flexChart">
    <div class="chartContent">
      <div class="content">Fortschritt bei den Einsparungszielen 2030</div>
      <div class="content content_sans color3">100&nbsp;% bis 2030</div>
    </div>
    <div class="chartContainer" ref="chartContainer">
      <div ref="chart" class="lineChart"></div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import _ from "lodash";

export default {
  props: {
    dataEmissSaving: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleResize: _.debounce(function () {
      this.windowWidth = window.innerWidth;
      const chartParent = this.$refs.chart;
      const svgNode = chartParent.querySelector("svg");
      chartParent.removeChild(svgNode);
      this.drawChart(this.$refs.chartContainer.clientWidth);
    }, 200),
    drawChart(containerWidth) {
      const chartWidth = containerWidth;
      //console.log("drawChart emissSaving", console.log(this.dataEmissSaving), containerWidth);

      // Set the width of the left axis
      const yAxisWidth = 16;
      const xAxisHeight = 16;

      const svg = d3.select(this.$refs.chart).append("svg");
      var maxTextWidth = this.dataEmissSaving.reduce((acc, curr) => {
        if (curr[0].length > acc.length) {
          return curr[0];
        } else {
          return acc;
        }
      }, "");

      const dummyText = svg.append("text").classed("axis-label", true).text(maxTextWidth);

      const yAxisWidth2 = dummyText.node().getBoundingClientRect().width + 5; // Add some padding to the width

      const margin = { top: 0, right: 0, bottom: 0, left: yAxisWidth2 };
      const width = chartWidth - margin.left - margin.right;
      const height = 94 - margin.top - margin.bottom;

      dummyText.remove();

      svg
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g");

      const xScale = d3.scaleLinear().domain([0, 100]).range([0, width]);

      const yScale = d3
        .scaleBand()
        .domain(this.dataEmissSaving.map((d) => d[0]))
        .range([0, height])
        .padding(0.1);

      const xAxis = d3.axisBottom(xScale).ticks(0).tickSizeInner(-height);

      const yAxis = d3.axisLeft(yScale).tickSize(0);

      svg
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`)
        .call(yAxis)
        .classed("axis-label", true);

      const stackedData = d3.stack().keys([1, 2])(this.dataEmissSaving);
      svg
        .selectAll(".stack")
        .data(stackedData)
        .join("g")
        .attr("class", "stack")
        .attr("transform", `translate(${margin.left},${margin.top})`)
        .selectAll("rect")
        .data((d) => d)
        .join("rect")
        .attr("y", (d, i) => i * (yScale.bandwidth() + 2))
        .attr("height", yScale.bandwidth())
        // .attr("x", (d) => 0)
        // .attr("width", (d) => (d[1] === 100 && d[0] > 0 ? width : 0))
        .attr("x", (d) => xScale(d[0]))
        .attr("width", (d) => xScale(d[1]) - xScale(d[0]))
        .attr("fill", (d, i) => (d[1] === 100 && d[0] > 0 ? "var(--mm-orange-color4)" : "var(--mm-orange-color3)"));
      // .transition()  // remove animation
      // .delay((d, i) => 180 + i * 10)
      // .duration(500)
      // .attr("x", (d) => xScale(d[0]))
      // .attr("width", (d) => xScale(d[1]) - xScale(d[0]));

      svg
        .selectAll(".text")
        .data(this.dataEmissSaving)
        .join("text")
        .attr("class", "stacked-text")
        // .attr("x", (d) => margin.left)
        // .attr("opacity", 0)
        .attr("x", (d) => margin.left + xScale(d[1]) - 3)
        .attr("opacity", 1)
        .attr("y", (d) => yScale(d[0]) + yScale.bandwidth() / 2 + 4.75)
        .attr("text-anchor", "end")
        .attr("height", 14)
        //.text((d) => `${d[1]}%`);
        .text((d, i) => `${d[1]}`);
      // .transition()  // remove animation
      // .delay((d, i) => 180 + i * 10)
      // .duration(500)
      // .attr("x", (d) => margin.left + xScale(d[1]) - 3)
      // .attr("opacity", 1);
    },
  },
  watch: {
    dataEmissSaving() {
      //console.log("watch", this.dataEmissSaving);
      let chartWidth = this.$refs.chartContainer.clientWidth;
      this.drawChart(chartWidth);
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.stacked-text {
  fill: white;
  font-size: 13px;
  font-family: "DV Source Sans 3", Helvetica, Arial, sans-serif;
  font-weight: 400;
}
</style>
